import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import bgImage from '@/assets/Eagle-Head.png';
import { useUser } from '@/hooks/user-user';
import { RoutePath } from '@/lib/routes';

const ReturnUser = ({
  message,
  counter,
  reRoute = true,
  logout = true,
  routeTo = '/' as RoutePath,
}: {
  message: string;
  counter?: number;
  reRoute?: boolean;
  routeTo?: RoutePath;
  logout?: boolean;
}) => {
  const router = useNavigate();
  const { signOut } = useUser();
  const COUNTER = counter ? counter * 1000 : 5000;
  const [timer, setTimer] = useState(COUNTER);

  useEffect(() => {
    logout && signOut();

    const intervalId = setInterval(() => {
      setTimer((prev) => {
        const newTime = prev - 1000;

        if (newTime <= 0) {
          clearInterval(intervalId);
          reRoute && router(routeTo);
        }
        return newTime;
      });
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          height: '25vh',
        }}></div>

      <p className="text-center">
        {`${message}  Sei werden in ${timer / 1000}
          Sekunden weitergeleitet.`}
      </p>
    </div>
  );
};

export default ReturnUser;
